/* eslint-disable jsx-a11y/no-onchange */
import { useEffect, useState } from 'react';
import MarkdownRender from 'components/markdown-render';
import i18n, { SettingsType } from 'utils/i18n';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import Layout from './master-layout';
import CertificateItem from 'components/certificate-item';
import { useUserData, assessmentStatus } from 'utils/user';
import AssessmentQuizForm from 'components/assessment-quiz';
import Assessment from 'components-new/assessment';
import StartAssessmentButton from 'components/start-assessment-button';

import ProgressHexagon from 'components-new/progress-hexagon';
import assessmentApi from '../apiFrontend/assessmentApi';

type AssessmentPageProps = {
  data: Assessment;
};

enum QuizType {
  single = 'singlePage',
  multi = 'multiPage',
}

export const AssessmentPage: React.FC<AssessmentPageProps> = ({ data }) => {
  const { locale, asPath, query, push } = useRouter(); // eslint-disable-line
  const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'] as SettingsType;
  const { loggedIn, login, achievements } = useUserData();
  const [answers, setAnswers] = useState<Record<string, Record<string, string>>>({});
  const [status, setStatus] = useState<AssessmentStatus | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [percentageCorrect, setPercentageCorrect] = useState(null);
  // const { refetch: assessmentStatusRefetch, isUninitialized, data: assessmentStatusData } = assessmentStatusApi.useGetAssessmentStatusQuery('12PmMGAdiPSQIJumdbu911');

  let showQuiz: Quiz | null | any = null;
  let quizType: QuizType;
  const completed = query.step === 'completed';

  if (query.step && data.quizSteps.find((quizStep) => quizStep.meta.id === query.step) && loggedIn) {
    showQuiz = data.quizSteps.find((quizStep) => quizStep.meta.id === query.step) as Quiz;
    quizType = QuizType.single;
  }

  if (query.step && data.assessmentStepsCollection?.sys?.id && loggedIn) {
    showQuiz = data.assessmentStepsCollection as any;
    quizType = QuizType.multi;
  }

  const assessmentPassed = !!achievements.find(
    (ach) => ach.contentId === data.meta.id && ach.type === 'AssessmentComplete'
  );

  const goToSlide = (quizId: string): void => {
    push(`${asPath.split('?')[0]}?step=${quizId}`);
  };

  const onSubmit = async (answersForPage: Record<string, string>): Promise<void> => {
    console.log('submitttttt', {
      assessmentId: data.meta.id,
      learningPathId: data.meta.parent.id,
      locale,
      path: asPath.split('?')[0],
      answers: answersForPage,
    });
    setSubmitting(true);
    const res = await fetch('/api/set-assessment-updated', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        assessmentId: data.meta.id,
        learningPathId: data.meta.parent.id,
        locale,
        path: asPath.split('?')[0],
        answers: answersForPage,
        step: query.step,
      }),
    });
    if (res.status === 401) {
      login();
    } else if (res.status !== 200) {
      console.log('ERROR', res.statusText);
    } else {
      const result = await res.json();
      setPercentageCorrect(result.percentageCorrect);
      setAnswers({});

      if (result.action === 'goto') {
        goToSlide(result.step);
      }
      if (result.action === 'completed') {
        goToSlide('completed');
      }
    }

    setSubmitting(false);
  };

  const onSubmitNew = async (
    answersForPage: [
      {
        'content-id': string;
        'content-question-id': string;
        'content-answer-id': string;
      }
    ],
    correctAnswersCount: number,
    wrongAnswersCount: number,
    totalAnswersCount: number
  ): Promise<void> => {
    console.log('Submitting', {
      assessmentId: data.meta.id,
      learningPathId: data.meta.parent.id,
      locale,
      path: asPath.split('?')[0],
      answers: answersForPage,
      correctAnswersCount,
      wrongAnswersCount,
      totalAnswersCount,
    });
    setSubmitting(true);
    const res = await fetch('/api/set-assessment-new-updated', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        assessmentId: data.meta.id,
        learningPathId: data.meta.parent.id,
        locale,
        path: asPath.split('?')[0],
        answers: answersForPage,
        step: query.step,
        correctAnswersCount,
        wrongAnswersCount,
        totalAnswersCount,
      }),
    });
    if (res.status === 401) {
      login();
    } else if (res.status !== 200) {
      console.log('ERROR', res.statusText);
    } else {
      const result = await res.json();

      if (result.action === 'goto') {
        goToSlide(result.step);
      } else if (result.action === 'completed') {
        goToSlide('completed');
      }
    }

    setPercentageCorrect(Math.round((correctAnswersCount / totalAnswersCount) * 100));
    setSubmitting(false);
  };

  const currentStepIndex = showQuiz && data.quizSteps.findIndex((item) => item.meta.id === showQuiz.meta.id);

  console.log('AssessmentPage', data, showQuiz, quizType, currentStepIndex);

  const getText = () => {
    switch (true) {
      case status?.claimed:
        return <h2 className="h3">{dictionary.assessmentPassedAndClaimed}</h2>;
      case status?.status === 'Passed':
        return (
          <h2 className="h3">
            {percentageCorrect && (
              <>
                <span>{dictionary.answeredCorrectly.replace('{{percentage}}', `${percentageCorrect}`)}</span>
                <br />
              </>
            )}
            <span>{dictionary.congratulationsPassedAssessment}</span>
            <br />
            <span>{dictionary.assessmentPassedNowClaim}</span>
          </h2>
        );
      // case status?.status === 'NeverStarted' && !query.step:
      //   return (
      //     <h2 className="h3">{dictionary.getYourCertificate.replace('{{certificateName}}', data.certificate.name)}</h2>
      //   );
      case (status?.status === 'Failed' && !query.step) || (status?.status === 'Failed' && completed):
        return (
          <>
            {percentageCorrect !== null && (
              <h2 className="h3">
                <>
                  <span>{dictionary.answeredCorrectly.replace('{{percentage}}', `${percentageCorrect}`)}</span>
                  <br />
                </>
                <span>{dictionary.pleaseTryAgainPercentage}</span>
              </h2>
            )}
          </>
        );
      // case !!query.step:
      //   return (
      //     <>
      //       <div className="certificate-text">
      //         {/* {!data.meta.parent.hidden && (
      //           <p>{dictionary.youMustAnswer.replace('{{percentToComplete}}', `${status?.percentToComplete}`)}</p>
      //         )} */}
      //         {/* {!data.meta.parent.hidden && <p>{dictionary.goodLuck}</p>} */}
      //       </div>
      //     </>
      //   );
      default:
        return null;
    }
  };

  return (
    <Layout
      breadcrumb={
        data.meta.parent.hidden ? [data.meta.breadcrumb[data.meta.breadcrumb.length - 1]] : data.meta.breadcrumb
      }
      title={data.meta.title}
      description={data.meta.description}
      hidden={data.meta.parent.hidden}
    >
      <StyledAssessmentPage className="small-outer-padding assessment-page">
        <div className="card">
          <ProgressHexagon status={assessmentStatus(achievements, data, status?.status)} />
          <div className="inner">
            <div className="image">
              {data.icon ? (
                <div className="header-icon">
                  <Image
                    src={data.icon.url}
                    width={data.icon.width}
                    height={data.icon.height}
                    alt={data.icon.title}
                    sizes="112px"
                    quality={100}
                  />
                </div>
              ) : (
                <div className="empty-header-icon"></div>
              )}
            </div>
            <div className="content">
              <>
                <h1>{data.title}</h1>
                {getText()}

                {data.certificate && (
                  <div className="certs">
                    <CertificateItem certificate={data.certificate} status={status} />
                  </div>
                )}

                {console.log('data.body', data.body)}
                {data.body && !assessmentPassed && <MarkdownRender markdown={data.body} />}

                <StartAssessmentButton
                  assessmentId={data.meta.id}
                  setAnswers={setAnswers}
                  setStatus={setStatus}
                  status={status}
                  percentageCorrect={percentageCorrect}
                />

                {showQuiz && !completed && !assessmentPassed && (
                  <>
                    <hr />
                    {/* {showQuiz.title && <h3>{showQuiz.title}</h3>} */}
                    {showQuiz.body && <MarkdownRender markdown={showQuiz.body} />}
                    {quizType === QuizType.single && (
                      <AssessmentQuizForm
                        quiz={showQuiz.quiz}
                        selectedAnswers={answers[showQuiz.meta.id] || {}}
                        submitting={submitting}
                        stepNum={currentStepIndex + 1}
                        totalSteps={data.quizSteps.length}
                        goBack={() => goToSlide(data.quizSteps[currentStepIndex - 1].meta.id)}
                        onComplete={(selectedData) => {
                          setAnswers({ ...answers, [showQuiz.meta.id]: selectedData });
                          onSubmit(selectedData);
                        }}
                      />
                    )}
                    {quizType === QuizType.multi && (
                      <Assessment
                        quiz={showQuiz}
                        // selectedAnswers={answers[showQuiz.meta.id] || {}}
                        submitting={submitting}
                        stepNum={currentStepIndex + 1}
                        totalSteps={showQuiz.assessmentPagesCollection.items.length}
                        onComplete={onSubmitNew}
                      />
                    )}
                  </>
                )}
              </>
            </div>
          </div>
        </div>
      </StyledAssessmentPage>
    </Layout>
  );
};

const StyledAssessmentPage = styled.article`
  margin-top: 1.5rem;
  margin-bottom: 3rem;

  .units {
    margin: 16px 0;
    margin-left: 38px;
  }

  .card {
    background: var(--body-background);
    border: 1px solid var(--border-white-high-contrast);
    box-shadow: 0 1.6px 3.6px 0 var(--box-shadow-medium), 0 0.3px 0.9px 0 var(--box-shadow-light);
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .inner {
    display: flex;
    padding: 1.5rem;
    position: relative;
  }

  .xp-hexagon {
    top: 1rem;
    right: 4rem;
  }

  .image {
    width: 112px;

    .empty-header-icon {
      width: 112px;
      height: 112px;
      background: #52b3c0;
      border: 3px solid #438c94;
      border-radius: 50%;
    }
  }

  .content {
    padding: 1.5rem;
    flex: 1 1 0;

    .h3 {
      font-size: 1.125rem;
      margin-bottom: 0;
    }

    .learning-objectives {
      margin: 1rem 0;
      font-size: 0.875rem;

      ul {
        margin: 16px 0;
        margin-left: 38px;
        li {
          list-style: disc none outside;
        }
      }
    }

    .buttons {
      display: flex;
      gap: 0.5rem;
      margin: 1rem 0;
    }
  }
`;

export default AssessmentPage;
